import FormsortWebEmbed from '@formsort/web-embed-api';

import { docReady } from './docReady';

docReady(() => {
  const formsort = document.getElementById('formsort-form');
  console.log(formsort);
  if (formsort) {
    console.log(formsort.dataset);
    const props = JSON.parse(formsort.dataset.props);
    const embed = FormsortWebEmbed(document.body, {
      style: { width: '100%', height: '100%' }
    });
    embed.loadFlow(props.client, props.flow, props.variant, ['gq_token', props.token]);
    embed.addEventListener('FlowFinalized', () => {
      document.getElementById('complete-party').submit();
      // DO we post a hidden form here for completion?
      //   console.log('Flow has loaded!');
    });
  }
});
